import { GameConstants } from "./GameConstants";
import { GameVars } from "./GameVars";

export class GameManager {

    public static init(): void {

        GameManager.initGameDistributionSDK();

        GameVars.intitialised = true;

        GameVars.currentLevel = 1;
        GameVars.difficulty = GameConstants.DIFFICULTY_EASY;

        if (GameVars.currentScene.sys.game.device.os.desktop) {

            GameVars.scaleY = 1;

        } else {

            GameVars.currentScene.game.scale.displaySize = GameVars.currentScene.game.scale.parentSize;
            GameVars.currentScene.game.scale.refresh();

            const aspectRatio = window.innerHeight / window.innerWidth;
            GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / aspectRatio;
        }

        GameManager.readGameData();
    }

    public static initGameDistributionSDK(): void {

        window["GD_OPTIONS"] = {
            "gameId": "c32bc08d5c0c44dbb55e16e1a4e6ac3c",
            "onEvent": function(event: any): any {
                switch (event.name) {
                    case "SDK_GAME_START":
                        if (GameVars.typeAd === "BoardScene") {
                            GameManager.enterBoardScene(GameVars.levelAd);
                        } else if (GameVars.typeAd === "SplashScene") {
                            GameManager.enterSplashScene();
                        } else if (GameVars.typeAd === "DifficultyScene") {
                            GameManager.enterDifficultySelectionScene();
                        } else if (GameVars.typeAd === "DifficultyScene") {
                            GameManager.enterDifficultySelectionScene();
                        } else if (GameVars.typeAd === "NextLevel") {
                            GameManager.goToNextLevel();
                        }
                        break;
                    case "SDK_GAME_PAUSE":
                        break;
                    case "SDK_GDPR_TRACKING":
                        console.log("SDK_GDPR_TRACKING");
                        break;
                    case "SDK_GDPR_TARGETING":
                        console.log("SDK_GDPR_TARGETING");
                        break;
                    default:
                        break;
                }
            },
        };
        (function(d: any, s: any, id: any): any {
            var js: any, fjs: any = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://html5.api.gamedistribution.com/main.min.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, "script", "gamedistribution-jssdk"));
    }

    public static readGameData(): void {

        GameManager.getGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            function (gameData: string): void {

                if (gameData) {
                    GameVars.gameData = JSON.parse(gameData);
                } else {
                    GameVars.gameData = {
                        muted: false,
                        achievedEasyLevel: 0,
                        achievedMediumLevel: 0,
                        achievedDifficultLevel: 0
                    };
                }

                GameManager.startGame();
            }
        );
    }

    public static restoreGameData(): void {

        GameVars.gameData = {
            muted: false,
            achievedEasyLevel: 0,
            achievedMediumLevel: 0,
            achievedDifficultLevel: 0
        };

        GameManager.writeGameData();
    }

    public static setCurrentScene(scene: Phaser.Scene): void {

        GameVars.currentScene = scene;
    }

    public static onGameAssetsLoaded(): void {

        GameManager.enterSplashScene();
        // GameManager.enterDifficultySelectionScene();
        // GameManager.enterLevelSelectionScene();
        // GameManager.enterBoardScene();
    }

    public static enterSplashScene(): void {

        GameVars.currentScene.scene.start("SplashScene");
    }

    public static enterDifficultySelectionScene(): void {

        GameVars.currentScene.scene.start("DifficultySelectionScene");
    }

    public static enterLevelSelectionScene(difficutly?: string): void {

        GameVars.difficulty = difficutly || GameVars.difficulty;

        GameVars.currentScene.scene.start("LevelSelectionScene");
    }

    public static enterBoardScene(level?: number): void {

        GameVars.currentLevel = level || GameVars.currentLevel;

        GameVars.currentScene.scene.start("BoardScene");
    }

    public static goToNextLevel(): void {

        GameVars.currentLevel++;

        if (GameVars.difficulty === GameConstants.DIFFICULTY_EASY && GameVars.currentLevel > GameConstants.TOTAL_EASY_LEVELS) {
            GameVars.currentLevel = 1;
            GameVars.difficulty = GameConstants.DIFFICULTY_NORMAL;
        } else if (GameVars.difficulty === GameConstants.DIFFICULTY_NORMAL && GameVars.currentLevel > GameConstants.TOTAL_NORMAL_LEVELS) {
            GameVars.currentLevel = 1;
            GameVars.difficulty = GameConstants.DIFFICULTY_HERO;
        }

        GameVars.currentScene.scene.start("BoardScene");
    }

    public static writeGameData(): void {

        GameManager.setGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            GameVars.gameData,
            function (): void {
                GameManager.log("game data successfully saved");
            }
        );
    }

    public static log(text: string, error?: Error): void {

        if (!GameConstants.VERBOSE) {
            return;
        }

        if (error) {
            console.error(text + ":", error);
        } else {
            console.log(text);
        }
    }

    private static startGame(): void {

        GameVars.currentScene.scene.start("PreloadScene");
    }

    private static getGameStorageData(key: string, successCb: Function): void {

        const gameDataStr = localStorage.getItem(key);
        successCb(gameDataStr);
    }

    private static setGameStorageData(key: string, value: any, successCb: Function): void {

        localStorage.setItem(key, JSON.stringify(value));
        successCb();
    }
}
